import type { FieldId } from '../../../../common/types/field';
import type { ChangeId, RegisteredFieldsMap } from '../../types';

export const fieldWasRegistered = (
	registeredFields: RegisteredFieldsMap,
	changeId: ChangeId,
	fieldId: FieldId,
	appId: string,
): boolean => !!registeredFields[appId]?.[changeId]?.includes(fieldId);
